import axios from "axios";

export default { getAll, get };

const serviceRootUrl = `/api/tenants`;

export function getAll() {
  return axios.get(serviceRootUrl);
}

export function get(id) {
  return axios.get(`${serviceRootUrl}/${id}`);
}